import { Check } from "../lib/icons";

export interface MetricRevisionControlsProps {
  /** Whether the current metric can be approved. */
  canApprove?: boolean;
  /** Whether the current metric can continue through the revision flow. */
  canContinueEditing?: boolean;
  /** Disables available actions while a revision command is in progress. */
  isBusy?: boolean;
  onApprove?: () => void;
  onContinueEditing?: () => void;
}

/**
 * Controlled actions for a metric revision prompt. Availability and busy state
 * are supplied by the caller; this component only renders and reports actions.
 */
export function MetricRevisionControls({
  canApprove = false,
  canContinueEditing = false,
  isBusy = false,
  onApprove,
  onContinueEditing,
}: MetricRevisionControlsProps) {
  if (!canApprove && !canContinueEditing) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-wrap gap-2">
      {canApprove && (
        <button
          type="button"
          disabled={isBusy}
          onClick={onApprove}
          className="inline-flex cursor-pointer items-center gap-1.5 rounded-[8px] border-0 bg-(--brand-navy) px-3 py-1.5 text-[13px] font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50"
        >
          <Check size={14} />
          Approve metric
        </button>
      )}
      {canContinueEditing && (
        <button
          type="button"
          disabled={isBusy}
          onClick={onContinueEditing}
          className="cursor-pointer rounded-[8px] border border-(--border-default) bg-(--bg-white) px-3 py-1.5 text-[13px] font-medium text-(--fg-secondary) disabled:cursor-not-allowed disabled:opacity-50"
        >
          Continue editing
        </button>
      )}
    </div>
  );
}
